import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Button,
  Dropdown,
  InputGroup,
  Form,
  Table,
} from "react-bootstrap";
import {
  FaPlus,
  FaCog,
  FaFilter,
  FaRedo,
  FaSearch,
  FaSort,
  FaToggleOff,
  FaToggleOn,
  FaEdit,
  FaTrashAlt,
} from "react-icons/fa";
import {
  getRegionsList,
  updateRegionStatus,
  deleteRegion,
} from "../../services/Organization-services.js";
import { getMethods } from "../../services/utilityFunctions";
import MasterTable from "../../views/dashboard/widget/MasterTabel";
import AddRegionForm from "../FormComponents/AddRegion.js";
import { useGlobalState } from "../../services/hostelConst";

const RegionTable = () => {
  const [isInitialized, setIsInitialized] = useState(false);
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
  } = useGlobalState();
  useEffect(() => {
    resetAdvanceFilterData();
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
        region: true,
        site: true,
        department: true,
      };
    });
    setIsInitialized(true);
    return () => {};
  }, []);
  return (
    <>
      <MasterTable
        getTableData={getRegionsList}
        tab1={"Organization"}
        tab2={"Regions"}
        actions={{
          status: true,
          edit: true,
          delete: true,
        }}
        AddForm={AddRegionForm}
        updateStatus={updateRegionStatus}
        deleteRow={deleteRegion}
      />
      
    </>
  );
};

export default RegionTable;
